module.exports = __webpack_public_path__ + "static/media/1.caa38fdb.png";